// 前端路由：登录 + 移动端告警 / 设备
export default [
  {
    path: '/',
    name: 'index',
    meta: { title: '首页', auth: 1 },
    component: () => import('@/views/index.jsx'),
    children: [
      {
        // 告警模块：项目上下文走 store / query（syncProjectFromUrl），path 不再带 project_id
        path: '/alarm',
        name: 'alarm',
        meta: { title: '告警', auth: 1 },
        component: () => import('@/views/alarm/index.jsx'),
        redirect: '/alarm/list',
        children: [
          {
            path: '/alarm/list',
            name: 'alarm-list',
            meta: { title: '告警列表', auth: 1 },
            component: () => import('@/views/alarm/list/index.jsx'),
          },
          {
            path: '/alarm/detail/:id',
            name: 'alarm-detail',
            meta: { title: '告警详情', auth: 1 },
            component: () => import('@/views/alarm/detail/index.jsx'),
          },
        ],
      },
      {
        // 设备模块：项目上下文走 store / query（syncProjectFromUrl），path 不再带 project_id
        path: '/sensor',
        name: 'sensor',
        meta: { title: '设备', auth: 1 },
        component: () => import('@/views/sensor/index.jsx'),
        redirect: '/sensor/list',
        children: [
          {
            path: '/sensor/list',
            name: 'sensor-list',
            meta: { title: '设备列表', auth: 1 },
            component: () => import('@/views/sensor/list/index.jsx'),
          },
          {
            path: '/sensor/detail/:sn',
            name: 'sensor-detail',
            meta: { title: '设备详情', auth: 1 },
            component: () => import('@/views/sensor/detail/index.jsx'),
          },
          {
            path: '/sensor/add',
            name: 'sensor-add',
            meta: { title: '添加设备', auth: 1 },
            component: () => import('@/views/sensor/add/index.jsx'),
          },
          {
            path: '/sensor/chart-fullscreen',
            name: 'sensor-chart-fullscreen',
            meta: { title: '时序图全屏', auth: 1 },
            component: () => import('@/views/sensor/chart-fullscreen/index.jsx'),
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    // 仅微信绑定（?bind=1），非绑定入口由守卫重定向到 /auth-fail
    meta: { title: '绑定账号', auth: 0 },
    component: () => import('@/views/login/index.jsx'),
  },
  {
    path: '/auth-fail',
    name: 'auth-fail',
    meta: { title: '无法访问', auth: 0 },
    component: () => import('@/views/auth-fail/index.jsx'),
  },
]
